import axios from 'axios'
import { baseURL } from './config.js'
import qs from 'qs'

export default {
  productList(params) { // 产品列表
    const url =  baseURL + '/tbProduct/list';
    return axios.post(url, qs.stringify(params));
  },
  setProductList(params) { // 新增/修改
    const url =  baseURL + '/tbProduct/modify';
    return axios.post(url, qs.stringify(params));
  },
  delProductList(params) { // 删除
    const url =  baseURL + '/tbProduct/delete';
    return axios.post(url, qs.stringify(params));
  },
  listDel(params) { // 产品列表
    const url =  baseURL + '/tbProduct/listDel';
    return axios.post(url, qs.stringify(params));
  }
  
}


// WEBPACK FOOTER //
// ./src/api/product.js